var app = angular.module('leonardo');

var FileService = function(deviceDetector) {

  var File = window.File;

  if (_.contains(['ms-edge', 'ie'], deviceDetector.browser)) {
    var _classCallCheck = function(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var _possibleConstructorReturn = function(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };

    var _inherits = function(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) {
        subClass.__proto__ = superClass
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__;
      }
    };

    try {
      new File([], '');
    } catch (e) {
      File = function (_Blob) {
        _inherits(File, _Blob);

        File = function(chunks, filename) {
          var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          _classCallCheck(this, File);

          var _this = _possibleConstructorReturn(this, _Blob.call(this, chunks, opts));

          _this.lastModifiedDate = new Date();
          _this.lastModified = +_this.lastModifiedDate;
          _this.name = filename;
          return _this;
        };
        return File;
      }(Blob);
    }
  }

  return File;

};

app.factory('FileService', ['deviceDetector', FileService]);
